import {SOURCE_VECTOR} from 'Map/tier/styleParts/styleResolver';
import tierProxy from 'Map/tier/tierProxy';
import mapTierFactory, {TIER_TYPE} from 'Map/tier/mapTier';

const POSITION_MAP_TIER = 1;
const POSITION_BUILDINGS_TIER = 4;
const POSITION_LABELS_TIER = 5;

function createBaseMapTier(tierOptions) {
    return tierProxy(mapTierFactory(tierOptions, POSITION_MAP_TIER, TIER_TYPE.BASE));
}

function createLabelMapTier(tierOptions) {
    return tierProxy(mapTierFactory(tierOptions, POSITION_LABELS_TIER, TIER_TYPE.LABELS));
}

function createBuildingsMapTier(tierOptions) {
    return tierProxy(mapTierFactory(tierOptions, POSITION_BUILDINGS_TIER, TIER_TYPE.BUILDINGS));
}

export default (options) => {
    const {layer} = options.theme.unwrap();

    if (layer === 'wms') {
        return [createBaseMapTier(options)];
    }

    if (layer === 'labels') {
        return [createLabelMapTier(options)];
    }

    const mapTiers = [createBaseMapTier(options), createLabelMapTier(options)];

    if (options.theme.getSource() === SOURCE_VECTOR) {
        mapTiers.push(createBuildingsMapTier(options));
    }

    return mapTiers;
};



// WEBPACK FOOTER //
// ./map/configurer/mapTiersFactory.js